const SPAIN_ID = 'es'
const MEXICO_ID = 'mx'

const isMexico = process.env.VUE_APP_LOCATION === MEXICO_ID
const isSpain = process.env.VUE_APP_LOCATION === SPAIN_ID

export {
    isMexico, isSpain
}
